import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const minLength = (n: number) => (control: FormControl) =>
    control.value && control.value.length < n ? { minLength: messages.validation.minLength.replace("${n}", "" + n) } : {};
